export const fileType = (fileName: string) => {
  return (
    fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) ||
    fileName
  );
};

export const camalise = (str: string) => {
  return str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (_m: string, chr: string) =>
      chr.toUpperCase()
    );
};

export const enumToCapitalizedString = (
  enumValue: string | undefined | null
): string => {
  if (enumValue == null) {
    return '';
  }
  return enumValue
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const truncateText = (text: string, limit: number): string => {
  if (!text) return '';
  if (text.length <= limit) return text;
  return text.substring(0, limit - 3) + '...';
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';

  const k = 1024;

  // Determine the appropriate unit
  if (bytes < k) {
    return `${bytes} B`;
  } else if (bytes < k * k) {
    const kb = bytes / k;
    return `${kb.toFixed(2)} KB`;
  } else if (bytes < k * k * k) {
    const mb = bytes / (k * k);
    return `${mb.toFixed(2)} MB`;
  } else {
    const gb = bytes / (k * k * k);
    return `${gb.toFixed(2)} GB`;
  }
};
